import { AssistantMessage } from '@/components/assistant/messages/AssistantMessage'
import { useT } from '@repo/ui/hooks'
import { MessageSquareWarning } from 'lucide-react'

export function AssistantErrorMessage() {
  const { t } = useT({ keyPrefix: 'assistant' })
  return (
    <AssistantMessage className="flex gap-2">
      <MessageSquareWarning className="mt-1 size-5" />
      <span className="">{t('cannotAnswer')}</span>
    </AssistantMessage>
  )
}
